import React, { useState, useEffect, useRef } from "react"
import InfoIcon from "@/public/icons/info.svg"
import ToolTip from "@/components/core/ToolTip/ToolTip"
import { addDataLayer } from "../ProductDetailView/analytics"
import { getStock } from "@/utils/cart"
import SelectDropdown from "@/components/core/SelectDropdown/SelectDropdown"

const TrimCalculator = props => {
  let tempVal = props?.RegionUOM !== "FT2" ? true : false
  let soldVal = !tempVal ? props.soldByBox : props.soldByUom
  const [linerLF, setLinerLF] = useState(
    props.totalNeeded ? props.totalNeeded : ""
  )
  const [overage, setOverage] = useState(props.overage ? props.overage : 15)
  const [customOverage, setCustomOverage] = useState("")
  const [totalOverage, setTotalOverage] = useState(0)
  const [totalLF, setTotalLF] = useState(0)
  const [pises, setPises] = useState(0)
  const [price, setPrice] = useState(0)
  const [displayPrice, setDisplayPrice] = useState(0)
  const [totalSFValue, setTotalSFValue] = useState(0)
  const [addToCartButtonDisable, setAddToCartButtonDisable] = useState(true)
  const overageList =
    typeof props?.customLabel?.overage === "object" &&
      props.customLabel.overage.length > 0
      ? props.customLabel.overage
      : [0, 5, 10, 15, 20, "Custom"]
  const [trimTooltip, setTrimTooltip] = useState({
    sqFeetTooltip: false,
    overageTooltip: false,
    totalCoverageTooltip: false,
  })
  const trimCalculationMainBlockElementRef = useRef(null)
  const [totalsoldValue, setTotalSoldValue] = useState(0)
  const [stockValue, setStockValue] = useState(0)
  const pricePerUnit = Number(props.price).toFixed(2)?.toLocaleString()

  useEffect(() => {
    let tmpTiletotalSoldValue = props.soldByBox / props.soldByUom
    let tmpTrimtotalSoldValue = 1 / props.soldByUom
    setTotalSoldValue(!tempVal ? tmpTiletotalSoldValue : tmpTrimtotalSoldValue)
    setTotalSFValue(Number(props?.priceByBox !== undefined && props?.priceByBox > 0 ? props?.priceByBox / tmpTiletotalSoldValue : 0)?.toFixed(2)?.toLocaleString())
  }, [props.soldByBox, props.soldByUom])

  useEffect(() => {
    if (!props.disableEcommerce) {
      getStock(props.sku).then(stock => {
        if (stock) {
          setStockValue(stock)
        }
        const cartItem =
          props?.cart?.lineItems?.find(
            item => item?.variant?.sku === props?.sku
          ) ?? {}
        const cartQuantity = cartItem?.quantity ?? 0
        if (cartQuantity > 0 && stock <= cartQuantity) {
          props.setOnChangeStockAlert({
            show: true,
            mssg: props.t("kf.pdp.label.noItemsToShip"),
          })
        } else if (stock < pises) {
          props.setOnChangeStockAlert({
            show: true,
            mssg: props.t("kf.pdp.label.availableToShip", { qty: stock }),
          })
        } else {
          props.setOnChangeStockAlert({
            show: false,
            mssg: "",
          })
        }
      })
    }
  }, [pises])

  const onChangeHandler = value => {
    if (!value) {
      setTotalLF(0)
      setTotalOverage(0)
      setPises(0)
      setPrice(0)
      localStorage.setItem("itemFinalPrice", 0)
      setDisplayPrice(0)
      setLinerLF("")
      return false
    }

    if (value < 0) {
      document.getElementById("txt_prod_price").value = 0
      setLinerLF(0)
      return false
    }
    document.getElementById("txt_prod_price").focus()
    const arr = value.split(".")
    if (value.length <= 5) {
      setLinerLF(value)
    } else if (arr.length <= 2 && arr[1].length <= 2) {
      setLinerLF(value)
    }
  }

  const trimTooltipHandler = (
    sqFeetTooltip,
    overageTooltip,
    totalCoverageTooltip,
    msg
  ) => {
    setTrimTooltip({
      sqFeetTooltip: sqFeetTooltip,
      overageTooltip: overageTooltip,
      totalCoverageTooltip: totalCoverageTooltip,
    })
    addDataLayer({
      title: "calculate footage info icon mouseover",
      productInfo: props?.analyticsProductInfo,
      toolTipProps: {
        isToolTip: true,
        toolTipValue: msg.toLowerCase(),
      },
    })
  }

  const onChangeCustomOverage = custVal => {
    if (custVal < 0) {
      document.getElementById("trim-calculator__overage-input-box").value = 0
      setCustomOverage(0)
      return false
    }

    let dot = custVal.split(".")
    if (dot.length === 2 || dot[0] === "") {
      setCustomOverage("")
    }
    if (dot.length !== 2 && dot[0] !== "" && custVal.length <= 2) {
      setCustomOverage(custVal)
    }
  }

  const onChangeOverage = value => {
    let res = 0
    setOverage(value)
    let tmpOverageVal =
      typeof value === "string" && value.toLowerCase() === "custom" ? 1 : value
    res = (Number(linerLF) * Number(tmpOverageVal)) / 100
    let total = res + Number(linerLF)
    let pres =
      soldVal !== undefined && soldVal > 0 ? Math.ceil(total) * soldVal : 0
    let boxPeice =
      soldVal !== undefined && soldVal > 0
        ? (props.soldByUom * Math.ceil(total)) / props.soldByBox
        : 0
    setPises(!tempVal ? Math.ceil(boxPeice) : Math.ceil(pres))
    let finalPrice = 0
    if (!props.disableEcommerce) {
      finalPrice =
        props?.priceByBox !== undefined && props?.priceByBox > 0
          ? (!tempVal
            ? stockValue < Math.ceil(boxPeice)
              ? stockValue
              : Math.ceil(boxPeice)
            : stockValue < Math.ceil(pres)
              ? stockValue
              : Math.ceil(pres)) * props.priceByBox
          : 0
    } else {
      finalPrice =
        props?.priceByBox !== undefined && props?.priceByBox > 0
          ? (!tempVal ? Math.ceil(boxPeice) : Math.ceil(pres)) *
          props.priceByBox
          : 0
    }
    if (props.SKUInventoryStatus) {
      finalPrice = props.price * Math.ceil(total);
    }
    setPrice(finalPrice)
    localStorage.setItem("itemFinalPrice", finalPrice)
    setDisplayPrice(Number(finalPrice)?.toFixed(2).toLocaleString())
    let tOverage = 0
    if (!props.disableEcommerce) {
      tOverage =
        soldVal !== undefined && soldVal > 0
          ? stockValue < Math.ceil(pres)
            ? stockValue / soldVal
            : Math.ceil(pres) / soldVal
          : 0
    } else {
      tOverage =
        soldVal !== undefined && soldVal > 0 ? Math.ceil(pres) / soldVal : 0
    }
    let tileOverage = 0
    if (!props.disableEcommerce) {
      tileOverage =
        soldVal !== undefined && soldVal > 0
          ? (props.soldByBox / props.soldByUom) *
          (stockValue < Math.ceil(boxPeice)
            ? stockValue
            : Math.ceil(boxPeice))
          : 0
    } else {
      tileOverage =
        soldVal !== undefined && soldVal > 0
          ? (props.soldByBox / props.soldByUom) * Math.ceil(boxPeice)
          : 0
    }
    setTotalOverage(!tempVal ? tileOverage : tOverage)
    setTotalLF(Math.ceil(total))
    addDataLayer({
      title: (props.customLabel && props.customLabel.overagename
        ? props.customLabel.overagename
        : props.staticTexts.overage
      ).toLowerCase(),
      productInfo: props?.analyticsProductInfo,
      calculated_Values: JSON.stringify({
        squareFeetNeeded: Number(linerLF),
        overage:
          typeof value === "string" && value.toLowerCase() === "custom"
            ? "custom"
            : Number(value),
        totalSquareFeet: Number(Math.ceil(total).toFixed(3)),
        totalCoverage: Number(tOverage.toFixed(3)),
        totalBoxes: Math.ceil(pres),
        totalPrice: Number(finalPrice.toFixed(3)),
      }),
    })
  }

  const onBlurHandler = value => {
    let addToCartRef = document.querySelector(".add-to-cart__main-button")
    let stickyHeaderRef = document.querySelector(".sticky-header__main-button")
    if (addToCartRef) {
      if ((Number(linerLF) && Number(pises) > 0) || Number(value) > 0) {
        addToCartRef.classList.remove("disabled")
        setAddToCartButtonDisable(false)
        stickyHeaderRef ? stickyHeaderRef.classList.remove("disabled") : ""
      } else {
        addToCartRef.classList.add("disabled")
        setAddToCartButtonDisable(true)
        stickyHeaderRef ? stickyHeaderRef.classList.add("disabled") : ""
      }
    }
    if (linerLF) {
      let res = 0
      let finalOverage =
        overage === "custom" || overage === "Custom" ? customOverage : overage
      res = (Number(linerLF) * Number(finalOverage)) / 100
      let total = res + Number(linerLF)
      let pres =
        soldVal !== undefined && soldVal > 0 ? Math.ceil(total) * soldVal : 0
      let boxPeice =
        soldVal !== undefined && soldVal > 0
          ? (props.soldByUom * Math.ceil(total)) / props.soldByBox
          : 0
      setPises(!tempVal ? Math.ceil(boxPeice) : Math.ceil(pres))
      let finalPrice = 0
      if (!props.disableEcommerce) {
        finalPrice =
          props?.priceByBox !== undefined && props?.priceByBox > 0
            ? (!tempVal
              ? stockValue < Math.ceil(boxPeice)
                ? stockValue
                : Math.ceil(boxPeice)
              : stockValue < Math.ceil(pres)
                ? stockValue
                : Math.ceil(pres)) * props.priceByBox
            : 0
      } else {
        finalPrice =
          props?.priceByBox !== undefined && props?.priceByBox > 0
            ? (!tempVal ? Math.ceil(boxPeice) : Math.ceil(pres)) *
            props.priceByBox
            : 0
      }
      if (props.SKUInventoryStatus) {
        finalPrice = props.price * Math.ceil(total);
      }
      setPrice(finalPrice)
      localStorage.setItem("itemFinalPrice", finalPrice)
      setDisplayPrice(Number(finalPrice)?.toFixed(2)?.toLocaleString())
      let tOverage = 0
      if (!props.disableEcommerce) {
        tOverage =
          soldVal !== undefined && soldVal > 0
            ? stockValue < Math.ceil(pres)
              ? stockValue / soldVal
              : Math.ceil(pres) / soldVal
            : 0
      } else {
        tOverage =
          soldVal !== undefined && soldVal > 0 ? Math.ceil(pres) / soldVal : 0
      }
      let tileOverage = 0
      if (!props.disableEcommerce) {
        tileOverage =
          soldVal !== undefined && soldVal > 0
            ? (props.soldByBox / props.soldByUom) *
            (stockValue < Math.ceil(boxPeice)
              ? stockValue
              : Math.ceil(boxPeice))
            : 0
      } else {
        tileOverage =
          soldVal !== undefined && soldVal > 0
            ? (props.soldByBox / props.soldByUom) * Math.ceil(boxPeice)
            : 0
      }
      setTotalOverage(!tempVal ? tileOverage : tOverage)
      setTotalLF(Math.ceil(total))
      addDataLayer({
        title: (props.customLabel && props.customLabel.footage
          ? props.customLabel.footage
          : props.staticTexts.calculateFootage
        ).toLowerCase(),
        productInfo: props?.analyticsProductInfo,
        calculated_Values: JSON.stringify({
          squareFeetNeeded: Number(value),
          overage: Number(finalOverage),
          totalSquareFeet: Number(Math.ceil(total).toFixed(3)),
          totalCoverage: Number(tOverage.toFixed(3)),
          totalBoxes: Math.ceil(pres),
          totalPrice: Number(finalPrice.toFixed(3)),
        }),
      })
    }
  }

  const onCustomOverageBlur = () => {
    onBlurHandler(linerLF)
  }
  useEffect(() => {
    if (props.shwoInModal || linerLF > 0 || linerLF !== "") {
      onBlurHandler(linerLF)
    }
  }, [props.priceByBox])
  useEffect(() => {
    trimCalculationMainBlockElementRef.current.classList.toggle(
      "remove-while-print",
      addToCartButtonDisable
    )
  }, [addToCartButtonDisable])

  const onKeyDownHandler = e => {
    if (e.which === 69) e.preventDefault()
    if (e.key === "Enter") {
      onBlurHandler(e.target.value)
    }
  }

  const getVerbiageforPrice = () => {
    switch (props?.RegionUOM) {
      case "EA":
        return props?.staticTexts?.each
      case "FT":
        return props?.staticTexts?.LinearF
      case "FT2":
        return props?.SKUInventoryStatus ? props?.staticTexts?.SquareF : props?.staticTexts?.perSF
      default:
        return ""
    }
  }

  const getPerVerbiage = () => {
    switch (props?.RegionUOM) {
      case "EA":
        return props?.staticTexts?.perEach
      case "FT":
        return props?.staticTexts?.perLF
      case "FT2":
        return props?.SKUInventoryStatus ? props?.staticTexts?.perSF : props?.staticTexts?.perBox
      default:
        return ""
    }
  }

  return (
    <div
      id="trim-calculator_main-block"
      ref={trimCalculationMainBlockElementRef}
      className="trimWrapper trim-calculator_main-block"
      totalOverage={totalOverage.toFixed(3)}
      totalPeices={pises}
      soldByUom={props.soldByUom ? props.soldByUom : ""}
      soldByBox={props.soldByBox ? props.soldByBox : ""}
      templateType={props.templateType ? props.templateType : ""}
    >
      <h2 className="header">
        {props.customLabel && props.customLabel.footage
          ? props.customLabel.footage
          : props.staticTexts.calculateFootage}
      </h2>
      <div className="inputWrapper">
        <div className="inputBox">
          <span className="inputBoxLabel">
            <label htmlFor="txt_prod_price" className="inputLabel">
              {tempVal
                ? (props?.SKUInventoryStatus ? props.staticTexts.squareFtNeeded : props.staticTexts.linearFtNeeded)
                : props.staticTexts.squareFtNeeded}
            </label>
            <img
              src={InfoIcon?.src}
              role="tooltip"
              tabIndex={0}
              onMouseOver={() =>
                trimTooltipHandler(
                  true,
                  false,
                  false,
                  props.customLabel && props.customLabel.ftneededToolTip
                    ? props.customLabel.ftneededToolTip
                    : tempVal
                      ? (props?.SKUInventoryStatus ? props.staticTexts.squareFtNeeded : props.staticTexts.linearFtNeeded)
                      : props.staticTexts.squareFtNeeded
                )
              }
              onMouseLeave={() =>
                setTrimTooltip({
                  sqFeetTooltip: false,
                  overageTooltip: false,
                  totalCoverageTooltip: false,
                })
              }
              onFocus={() =>
                trimTooltipHandler(
                  true,
                  false,
                  false,
                  props.customLabel && props.customLabel.ftneededToolTip
                    ? props.customLabel.ftneededToolTip
                    : tempVal
                      ? (props?.SKUInventoryStatus ? props.staticTexts.squareFtNeeded : props.staticTexts.linearFtNeeded)
                      : props.staticTexts.squareFtNeeded
                )
              }
              onBlur={() =>
                setTrimTooltip({
                  sqFeetTooltip: false,
                  overageTooltip: false,
                  totalCoverageTooltip: false,
                })
              }
              className="trimCalculatorTooltipIcon"
            />
            <div
              className={`trim-calculator__list-tooltip${trimTooltip.sqFeetTooltip ? "--show" : "--hide"
                }`}
            >
              <div className="trim-calculator__list-tooltip-wrapper">
                <ToolTip
                  message={
                    props.customLabel && props.customLabel.ftneededToolTip
                      ? props.customLabel.ftneededToolTip
                      : tempVal
                        ? (props?.SKUInventoryStatus ? props.staticTexts.squareFtNeeded : props.staticTexts.linearFtNeeded)
                        : props.staticTexts.squareFtNeeded
                  }
                />
              </div>
            </div>
          </span>
          <input
            type="number"
            className="trim-calculator__square-ft-value"
            id="txt_prod_price"
            placeholder="0.000"
            value={linerLF}
            onChange={e => onChangeHandler(e.target.value)}
            onBlur={e => onBlurHandler(e.target.value)}
            onKeyDown={e => onKeyDownHandler(e)}
            label={tempVal
              ? (props?.SKUInventoryStatus ? props.staticTexts.squareFtNeeded : props.staticTexts.linearFtNeeded) 
              : props.staticTexts.squareFtNeeded}
            for={tempVal
              ? props.staticTexts.linearFtNeeded
              : props.staticTexts.squareFtNeeded}
          />
          <div className="labelLF">
            {tempVal ? (props?.SKUInventoryStatus ? props.staticTexts.sf : props.staticTexts.lf) : props.staticTexts.sf}
          </div>
        </div>
        <div className="inputBox">
          <span className="inputBoxLabel">
            <label htmlFor="trim-calculator__overage-value" className="inputLabel">
              {props.customLabel && props.customLabel.overagename
                ? props.customLabel.overagename
                : props.staticTexts.overage}
            </label>
            <img
              src={InfoIcon?.src}
              role="tooltip"
              tabIndex={0}
              onMouseOver={() =>
                trimTooltipHandler(
                  false,
                  true,
                  false,
                  props.customLabel && props.customLabel.overageNameToolTip
                    ? props.customLabel.overageNameToolTip
                    : props.staticTexts.overage
                )
              }
              onMouseLeave={() =>
                setTrimTooltip({
                  sqFeetTooltip: false,
                  overageTooltip: false,
                  totalCoverageTooltip: false,
                })
              }
              onFocus={() =>
                trimTooltipHandler(
                  false,
                  true,
                  false,
                  props.customLabel && props.customLabel.overageNameToolTip
                    ? props.customLabel.overageNameToolTip
                    : props.staticTexts.overage
                )
              }
              onBlur={() =>
                setTrimTooltip({
                  sqFeetTooltip: false,
                  overageTooltip: false,
                  totalCoverageTooltip: false,
                })
              }
              className="trimCalculatorTooltipIcon"
            />
            <div
              className={`trim-calculator__list-tooltip${trimTooltip.overageTooltip ? "--show" : "--hide"
                }`}
            >
              <div className="trim-calculator__list-tooltip-wrapper">
                <ToolTip
                  message={
                    props.customLabel && props.customLabel.overageNameToolTip
                      ? props.customLabel.overageNameToolTip
                      : props.staticTexts.overage
                  }
                />
              </div>
            </div>
          </span>
          <SelectDropdown
            id="trim-calculator__overage-value"
            data={overageList}
            value={overage}
            onChange={selectedValue => onChangeOverage(selectedValue)}
            label="overage"
          />
          {(overage === "custom" || overage === "Custom") && (
            <span className="custom-overage">
              <input
                type="number"
                value={customOverage}
                placeholder="0&nbsp;&nbsp;&nbsp;&nbsp;%"
                onChange={e => onChangeCustomOverage(e.target.value)}
                onBlur={onCustomOverageBlur}
                onKeyDown={e => onKeyDownHandler(e)}
                id="trim-calculator__overage-input-box"
                className={`${customOverage !== "" ? "overage-sign" : ""}`}
                min="0"
                inputmode="numeric"
                pattern="[0-9]*"
              />
              <span className="percentage-sign">%</span>
            </span>
          )}
        </div>
      </div>
      <div className="totalLFWrapper">
        <div className="labelText">
          {tempVal ? (props?.SKUInventoryStatus ? props.staticTexts.totalSF : props.staticTexts.totalLF ) : props.staticTexts.totalSF}
        </div>
        <div
          className="valText"
          id="trim-calculator__totalSquareFeet"
          value={totalLF.toFixed(2)}
        >
          {totalLF.toFixed(2)}{" "}
          <span className="text">
            {tempVal ? (props?.SKUInventoryStatus ? props.staticTexts.sf : props.staticTexts.lf )  : props.staticTexts.sf}
          </span>
        </div>
      </div>
      {!props?.SKUInventoryStatus ?
        <>
          <div className="totalBox">
            <div className="leftBox">
              <span>{props.staticTexts.totalCoverage}</span>
              <label>
                {props.staticTexts.whatYouWillReceive}
                <img
                  src={InfoIcon?.src}
                  role="tooltip"
                  tabIndex={0}
                  onMouseOver={() =>
                    trimTooltipHandler(
                      false,
                      false,
                      true,
                      props.customLabel && props.customLabel.totalCoverageToolTip
                        ? props.customLabel.totalCoverageToolTip
                        : props.staticTexts.totalCoverage
                    )
                  }
                  onMouseLeave={() =>
                    setTrimTooltip({
                      sqFeetTooltip: false,
                      overageTooltip: false,
                      totalCoverageTooltip: false,
                    })
                  }
                  onFocus={() =>
                    trimTooltipHandler(
                      false,
                      false,
                      true,
                      props.customLabel && props.customLabel.totalCoverageToolTip
                        ? props.customLabel.totalCoverageToolTip
                        : props.staticTexts.totalCoverage
                    )
                  }
                  onBlur={() =>
                    setTrimTooltip({
                      sqFeetTooltip: false,
                      overageTooltip: false,
                      totalCoverageTooltip: false,
                    })
                  }
                  className="trimCalculatorTooltipIcon"
                />
                <div
                  className={`trim-calculator__list-tooltip${trimTooltip.totalCoverageTooltip ? "--show" : "--hide"
                    }`}
                >
                  <div className="trim-calculator__list-tooltip-wrapper">
                    <ToolTip
                      message={
                        props.customLabel && props.customLabel.totalCoverageToolTip
                          ? props.customLabel.totalCoverageToolTip
                          : props.staticTexts.totalCoverage
                      }
                    />
                  </div>
                </div>
              </label>
            </div>
            <div className="rightBox">
              <div
                className="valText"
                id="trim-calculator__totalCoverage"
                value={totalOverage.toFixed(2)}
              >
                {totalOverage.toFixed(2)}{" "}
                <span className="text">
                  {tempVal ?  (props?.SKUInventoryStatus ? props.staticTexts.sf : props.staticTexts.lf ) : props.staticTexts.sf}
                </span>
              </div>
            </div>
          </div>
          <div className="totalBox">
            <div className="leftBox">
              <span>
                {tempVal
                  ? props.staticTexts.totalPieces
                  : props.staticTexts.totalBoxes}
              </span>
              <label>{`Product sold by the ${tempVal ? "Piece" : "Box"
                } (${props?.currencySign} ${totalsoldValue.toFixed(2)} ${tempVal ? "LF / Piece" : "SF / Box"
                })`}</label>
            </div>
            <div className="rightBox">
              <div
                className="valText"
                id="trim-calculator__totalBoxes"
                value={
                  !props.disableEcommerce
                    ? stockValue < pises
                      ? stockValue
                      : pises
                    : pises
                }
              >
                {!props.disableEcommerce
                  ? stockValue < pises
                    ? stockValue
                    : pises
                  : pises}{" "}
                <span className="text">
                  {tempVal ? props.staticTexts.pieces : props.staticTexts.boxes}
                </span>
              </div>
            </div>
          </div>
        </>
        : null}
      <div className="totalBox">
        <div className="leftBox">
          <span>Total Price</span>
          <label>{props?.RegionUOM !== "" ? `Price per ${getVerbiageforPrice()} (${props?.currencySign} ${pricePerUnit} ${getPerVerbiage()}) ` : null}</label>
        </div>
        <div className="rightBox">
          <div
            className="finalTotal"
            id="trim-calculator__finalTotal"
            price={price.toFixed(2)}
          >
            {`$${displayPrice}`}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TrimCalculator
